import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./LiveCard.css";

import { MdKeyboardArrowRight } from "react-icons/md";
import save from '../image/save.svg';
import share from '../image/share.svg';
import like from '../image/like.svg';

import { API_BASE_URL } from '../../utils'
import ShareModal from "./ShareModal";
import { Link } from "react-router-dom";
import axios from "axios";
import { DataSaverOff } from "@mui/icons-material";


const LiveCard = ({ data }) => {

  const userData = JSON.parse(localStorage.getItem("userData"));

  const [isLoaded, setIsLoaded] = useState(false);

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentShareUrl, setCurrentShareUrl] = useState('');
  const [shareTitle, setShareTitle] = useState('');
  const [userLocation, setUserLocation] = useState({ latitude: null, longitude: null });


  const uploadBase = `${API_BASE_URL}/master/assets/uploads/`;


  const isAbsURL = (url) => {
    const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
    return ABSOLUTE_URL_REGEX.test(url);
  }

  const getImageURL = (url) => {
    if (url) {
      if (isAbsURL(url)) {
        return url;
      } else {
        return uploadBase + url;
      }
    } else {
      return url;
    }
  }

  const eventUrl = (eventData) => {
    return `https://www.partywitty.com/${(eventData.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(eventData.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(eventData.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(eventData.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
  };





  const handleShare = (e, eventData) => {
    e.preventDefault();
    e.stopPropagation();

    const url = eventUrl(eventData);
    setCurrentShareUrl(url);
    setShareTitle(`Check out ${eventData.name} at ${eventData.clubName}`);
    setIsShareModalOpen(true);
  };


  function generateClubUrl(clubName, cityName, areaName) {
    const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");
    return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
  }

  const handleAddRemoveFav = async (e, eventData) => {
    e?.preventDefault();

    const formdata = new FormData();
    formdata.append("club_id", eventData.id);
    formdata.append("user_id", userData.id);

    try {
      const response = await axios.post(`${API_BASE_URL}/master/APIs/Common/addToFav`, formdata);

      if (response.status === 200) {
        const { is_fav } = response.data; // assuming backend returns this
        if (is_fav) {
          console.log("Added to favorites");
        } else {
          console.log("Removed from favorites");
        }
      } else {
        console.warn("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Failed to add/remove favorite:", error);
    }
  };

  // Distance calculation function
  const getDistanceFromLatLonInKm = useCallback((lat1, lon1, lat2, lon2) => {
    if (!lat1 || !lon1 || !lat2 || !lon2) return 0;

    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; // Radius of the Earth in km

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return Math.round(distance.toFixed(2));
  }, []);

  const distance = useMemo(() => {
    return getDistanceFromLatLonInKm(
      userLocation.latitude,
      userLocation.longitude,
      data?.latitude,
      data?.longitude
    );
  }, [userLocation, data?.latitude, data?.longitude, getDistanceFromLatLonInKm]);

  // Get user location on mount
  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });
        },
        (error) => {
          console.error('Error getting location:', error);
          // Don't show alert for better UX - just log the error
        },
        {
          timeout: 10000,
          enableHighAccuracy: false,
          maximumAge: 300000 // Cache for 5 minutes
        }
      );
    } else {
      console.error('Geolocation is not available in this browser.');
    }
  }, []);


  return (
    <>
      <div className="reel-card">
        {/* Header */}
        <div className="card-header">
          <img
            className="profile-img"
            src={getImageURL(data.clubLogo)}
            alt="Club"
          />
          <div className="header-text">
            <h4>
              <Link to={generateClubUrl(data?.clubName, data?.cityName, data?.areaName)} style={{ textDecoration: "none" }}>
                {data?.clubName}
              </Link>
            </h4>
            <p>
              {data?.areaName}, {data?.cityName},{" "}
              {distance > 0 ? `${distance}Kms` : ""}{" "}
              
            </p>

          </div>
          <div
            className="dots"
            onClick={(e) => handleShare(e, data)}
          >
            •••
          </div>
        </div>


        {/* Offer strip */}
        <div className="offer-strip">
          Add On up to 50% Extra on Food & Beverages
        </div>
        {/* Banner */}
        <div className="card-banner">

          <div className="image-wrapper">

            {!isLoaded && (
              <div className="ec-skeleton ec-shimmer"></div>
            )}
            <img
              src={getImageURL(data?.image)}
              alt="Live Music image"
              className={`event-img ${isLoaded ? 'visible' : 'hidden'}`}
              onLoad={() => setIsLoaded(true)}
            />
          </div>


          <div className="label-banner">{data?.event_date}</div>

          <div className="event-details">
            <h3>{data?.name}</h3>
            <p>{data?.clubName}</p>
            <div className="event-t-btn">
              <div className="event-info">
                <p>📅 {data?.event_date}</p>
                <p>⏰ {data?.event_time}</p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <Link to={`/event-book/${data?.club_id}/${data?.id}`} style={{ textDecoration: "none" }}>
          <div className="cta-button">Book Now <span className="arrow-icon-live"><MdKeyboardArrowRight /></span></div>
        </Link>


        <div className="card-icons">
          <div className="card-icons-right">
            <div onClick={(e) => handleAddRemoveFav(e, { id: data.club_id })} >
              <img src={like} alt="" />
            </div>
            <div>
              <img src={share} alt="" />
            </div>
          </div>
          <div>
            <img src={save} alt="" />
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer">
          {/* <p>❤️ Liked by XYZ Club and others</p> */}
          <div className="footer-text-skeleton">
            <p><div className="ec-skeleton ec-shimmer"></div></p>
          </div>
          <div className="icons">
            <span>🔗</span>
            <span>🔖</span>
          </div>
        </div>
      </div>
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        shareUrl={currentShareUrl}
        title={shareTitle}
      />
    </>
  );
};

export default LiveCard;
